<section role="region" aria-labelledby="h2Summary">
  <!-- Token: Trades -->
  <div class="sectionHeader" class="hidden">
    <h2 id="h2Summary">
      {{ 'k000030' | translate }}
    </h2>
  </div>
  <div class="summary">
<!-- Primera tarjeta blanca Nivel de Riesgo y valoraciones -->
<section class="card-white portfolio-sumary-card">
  <div class="header">
    <div class="">
      <span
        *ngIf="!editPortfolioName"
        class="spanLinkDark font-18px"
        (click)="editPortfolioNameClick($event)"
        #namePortfolio
        >{{ portfolioname }}
      </span>
      <mat-form-field *ngIf="editPortfolioName">
        <input
          matInput
          [value]="portfolioname"
          [formControl]="portfolionameFormControl"
          (blur)="blurPortfolioName($event)"
          #inputNamePortfolio
        />
        <mat-error
          *ngIf="
            !portfolionameFormControl.pristine &&
            portfolionameFormControl.hasError('required')
          "
        >
          {{ 'k001784' | translate }}
          <!-- // Token: Name is required -->
        </mat-error>
      </mat-form-field>

      <fa-icon
        class="ml-2 grey pointer"
        mat-button
        [icon]="['fal', 'pencil-alt']"
        (click)="editPortfolioNameClick($event)"
      >
      </fa-icon>
    </div>
    <!--
    <span class="tech-spacer"></span>
    <div class="blue-dark font-20px" *ngIf="option1">
      <fa-icon
        class="ml-2"
        mat-button
        icon="ellipsis-v"
        [matMenuTriggerFor]="portfolioSelect"
      ></fa-icon>
    </div>
    <mat-menu #portfolioSelect="matMenu" xPosition="before">
      <button mat-menu-item (click)="openPdf()">
        <span>
          <fa-icon class="mr-1" icon="file-pdf"></fa-icon>
          {{ 'k001783' | translate }}
        </span>
      </button>
    </mat-menu>
  --></div>
  <div class="content" *ngIf="!loaddingSummary; else elseBlock">
    <!--
    <div class="item-A" *ngIf="option1">
      <div>
        <span class="bold">{{ 'k001463' | translate }}</span>
        <fa-icon
          class="ml-1 pointer blue2"
          icon="info-circle"
          #tooltip0="matTooltip"
          matTooltip="{{ 'k001808' | translate }}"
          (mouseenter)="$event.stopImmediatePropagation()"
          (mouseleave)="$event.stopImmediatePropagation()"
          (click)="tooltip0.show()"
        >
        </fa-icon>
      </div>
      <div>{{ riskLevel }} &nbsp;({{ volatility | trPercent }})</div>
    </div>
    -->
    <!-- token: RISK LEVEL allows you to apply profiling criteria to your portfolio, which will help you have a clearer view of the risk assumed by your portfolio -->

    <div
      class="item-D pointer"
      (click)="openDialog(periodInitialDate, periodEndDate)"
    >
      <span class="font-color">{{ 'k000135' | translate }}</span>
      <!-- Token: From -->
      <span class="blue2"
        >&nbsp; {{ periodInitialDate | date : dateFormat }} &nbsp;</span
      >
      <span class="font-color">{{ 'k000136' | translate }}</span>
      <!-- Token: to -->
      <span class="blue2"
        >&nbsp; {{ periodEndDate | date : dateFormat }} &nbsp;</span
      >

      <fa-icon class="color4" mat-button [icon]="['fal', 'pencil-alt']">
      </fa-icon>
    </div>

    <div class="item-A">
      <div class="bold">
        {{ 'k000137' | translate }}
        <!-- Token: Valoración fecha inicial -->
      </div>
      <div class="">
        {{ valuationinitialdate | trCurrency : currency }}
      </div>
    </div>
    <div class="item-A">
      <div class="">
        {{ 'k000468' | translate }}
        <!-- Token: Aportaciones -->
      </div>
      <div class="">
        {{ contributions | trCurrency : currency }}
      </div>
    </div>
    <div class="item-A">
      <div class="">
        {{ 'k001785' | translate }}
        <!-- Token: Reembolsos -->
      </div>
      <div class="">
        {{ withdrawals | trCurrency : currency }}
      </div>
    </div>
    <div class="item-A">
      <div class="">
        {{ 'k001786' | translate }}
        <!-- Token: Total beneficio/perdida -->
      </div>
      <div class="blue2">
        {{
          totalprofitLossbeetweendates == -10000
            ? '-'
            : (totalprofitLossbeetweendates | trCurrency : currency)
        }}
      </div>
    </div>
    <div class="item-A" [ngClass]="HasCredits ? '' : 'sinborde'">
      <div class="bold">
        {{ 'k000141' | translate }}
        <!-- Token: Valoración fecha final -->
      </div>
      <div class="">
        {{ valuationenddate | trCurrency : currency }}
      </div>
    </div>
    <div *ngIf="HasCredits" class="item-A sinborde">
      <div class="bold">
        {{ 'k004011' | translate }}
        <!-- Token: Total liabilities -->
        <span
          matTooltip="{{ 'k004012' | translate }}"
          #tooltip="matTooltip"
          ><fa-icon [icon]="faCircleInfo" class="iconTooltip"></fa-icon
        ></span>
      </div>
      <div class="">
        {{ LiabilitiesValuation | trCurrency : currency }}
      </div>
    </div>
  </div>
</section>

<!-- Segunda tarjeta blanca porcentaje valoracion -->
<section class="card-white portfolio-sumary-card">
  <div class="header">
    <span class="blue-dark bold">{{ performaceProfitLossTitle | translate }}</span>
    <span class="tech-spacer"></span>
    <!--<span class="blue2 bold">{{ all | trPercentSignus }}</span>-->
  </div>

  <div class="content" *ngIf="!loaddingSummary; else elseBlock">
    <!-- Token: Última semana -->
    <div class="item-B">
      <div>{{ 'k001787' | translate }}</div>
      <div>{{ showProfitLossInClientPortal ? (lastwek | trCurrency : currency) : (lastwek | trPercentSignus) }}</div>
    </div>

    <!-- Token: 1 month -->
    <div class="item-B">
      <div>{{ 'k000109' | translate }}</div>
      <div>{{ showProfitLossInClientPortal ? (month1 | trCurrency : currency) : (month1 | trPercentSignus) }}</div>
    </div>

    <!-- Token: Año actual -->
    <div class="item-B">
      <div>{{ 'k001789' | translate }}</div>
      <div>{{ showProfitLossInClientPortal ? (ydt | trCurrency : currency) : (ydt | trPercentSignus) }}</div>
    </div>

    <!-- Token: 1 year -->
    <div class="item-B">
      <div>{{ 'k000110' | translate }}</div>
      <div>{{ showProfitLossInClientPortal ? (year1 | trCurrency : currency) : (year1 | trPercentSignus) }}</div>
    </div>

    <div class="item-B sinborde">
      <div>{{ 'k002341' | translate }}</div>
      <div>{{ showProfitLossInClientPortal ? (all | trCurrency : currency) : (all | trPercentSignus) }}</div>
    </div>
  </div>
</section>

<ng-template #elseBlock>
  <div class="loading-spinner">
    <tech-loading-peq></tech-loading-peq>
  </div>
</ng-template>
  </div>
</section>
